import { create } from 'zustand';
import axios from 'axios';
import { API_create_company } from '../constants';

// Mirrors Company.BUSINESS_TYPE_CHOICES on the backend.
const VALID_BUSINESS_TYPES = [
  'quick_service_restaurant',
  'full_service_restaurant',
  'bar',
  'cafe',
  'retail',
  'hotel',
  'other',
];

// Mirrors company_info.onboarding.PRIMARY_GOAL_CHOICES on the backend.
export const VALID_PRIMARY_GOALS = ['scheduling', 'training', 'both'];

const useCreateCompanyStore = create((set, get) => ({
  // Form data
  formData: {
    companyName: '',
    businessType: 'quick_service_restaurant',
    primaryGoal: '', // What to set up first; required, no preselection
    firstName: '',
    lastName: '',
    email: '',
    setupCompleted: false, // Tracks if setup has been completed
    // departments: ['Restaurant'],
  },
  
  // Current step/page
  currentStep: 0,
  
  // Total steps
  totalSteps: 6, // Welcome, Company Setup, Starting Modules, Admin Details, Confirmation, Company Created
  
  // Actions
  setFormData: (field, value) => set((state) => ({
    formData: {
      ...state.formData,
      [field]: value,
    },
  })),
  
  nextStep: () => set((state) => ({
    currentStep: Math.min(state.currentStep + 1, state.totalSteps - 1),
  })),
  
  previousStep: () => set((state) => ({
    currentStep: Math.max(state.currentStep - 1, 0),
  })),
  
  
  resetForm: () => set(() => ({
    formData: {
      companyName: '',
      businessType: 'quick_service_restaurant',
      primaryGoal: '',
      firstName: '',
      lastName: '',
      email: '',
      setupCompleted: false,
      // departments: ['Restaurant'],
    },
    currentStep: 0,
  })),
  
  // Validation helpers
  isStepValid: (step) => {
    const { formData } = get();
    switch (step) {
      case 0: // Welcome page
        return true;
      case 1: // Company setup
        return (
          formData.companyName.trim().length > 0 &&
          VALID_BUSINESS_TYPES.includes(formData.businessType)
        );
      case 2: // Starting modules
        return VALID_PRIMARY_GOALS.includes(formData.primaryGoal);
      case 3: // User details
        return formData.firstName.trim().length > 0 && 
               formData.lastName.trim().length > 0 &&
               formData.email.trim().length > 0 && 
               /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);
      case 4: // Confirmation
        return true;
      // case 5: // Departments
      //   return formData.departments && formData.departments.length > 0;
      case 5: // Company created
        return true;
      default:
        return false;
    }
  },

  // API calls
  createCompany: async () => {
    try {
      const { formData } = get();
      
      const response = await axios.post(API_create_company, {
        company_name: formData.companyName,
        business_type: formData.businessType,
        primary_goal: formData.primaryGoal,
        company_admin_first_name: formData.firstName,
        company_admin_last_name: formData.lastName,
        company_admin_email: formData.email,
        setup_type: 'standard',
      });

      console.log('Company created successfully:', response.data);
      return { success: true, data: response.data };
      
    } catch (error) {
      console.error('Error creating company:', error);
      
      return { 
        success: false, 
        error: error.response?.data?.error || 'Failed to create company. Please try again.'
      };
    }
  },
}));

export default useCreateCompanyStore;
